(function () {
  /**
   * @ngdoc module
   * @name binky.core.organizations.system-group
   * @description module that defines the SystemGroup model
   */
  angular.module('binky.core.organizations.system-group', [
    'binky.core.api.jil',
    'binky.core.common.list',
    'binky.core.common.member',
    'binky.core.lodash',
  ]);
})();
